import { useLocation, Link } from "react-router-dom";
import routes from "../routes";
import React from "react";

interface RouteItem {
  path: string;
  name: string;
}

interface BreadcrumbItem {
  pathname: string;
  name: string;
  active: boolean;
}

const AppBreadcrumb: React.FC = () => {
  const location = useLocation();
  const currentLocation = location.pathname;

  const getRouteName = (
    pathname: string,
    routes: RouteItem[],
  ): string | false => {
    const currentRoute = routes.find((route) => route.path === pathname);
    return currentRoute ? currentRoute.name : false;
  };

  const getBreadcrumbs = (location: string): BreadcrumbItem[] => {
    const breadcrumbs: BreadcrumbItem[] = [];

    location.split("/").reduce((prev, curr, index, array) => {
      const currentPathname = `${prev}/${curr}`;
      const routeName = getRouteName(currentPathname, routes);

      if (routeName) {
        breadcrumbs.push({
          pathname: currentPathname,
          name: routeName,
          active: index + 1 === array.length,
        });
      }

      return currentPathname;
    }, "");

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs(currentLocation);

  return (
    <nav className="text-sm text-muted-foreground space-x-1">
      <Link to="/" className="hover:underline">
        Home
      </Link>
      {breadcrumbs.map((breadcrumb, index) => (
        <span key={index}>
          <span className="mx-1">/</span>
          {breadcrumb.active ? (
            <span className="text-primary font-semibold">
              {breadcrumb.name}
            </span>
          ) : (
            <Link to={breadcrumb.pathname} className="hover:underline">
              {breadcrumb.name}
            </Link>
          )}
        </span>
      ))}
    </nav>
  );
};

export default React.memo(AppBreadcrumb);
